import React from 'react'
import './operations.css'

export const  Operations = () => {
    
    return (
        <>
        
        <div className="operations">
        <div className="heading"><h6>NOS OPERATIONS</h6></div>
        <div className="detail">
        <div className="row">
           <div className="column">
              <div className="card">
                <div className="icon-wrapper">
                    <img src="5.jpg" alt="" />
                 </div>
                 <div className="txt">
                    <h4>Conseils et suivi des procédures</h4>
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="icon-wrapper">
                <img src="6.jpg" alt="" />
              </div>
              <div className="txt"> 
                    <h4>Guide sur les procédures
                    <br/>d'exonération, abattement<br/></h4>
                </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="icon-wrapper">
                    <img src="7.jpg" alt="" />
              </div>
              <div className="txt"> 
                    <h4>Anticipation sur le suivi et la
                    <br/>procédure de sortie de vos<br/>
                    expéditions</h4>
                </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="icon-wrapper">
                    <img src="8.jpg" alt="" />
                 </div>
              <div className="txt"> 
                    <h4>Traitement des dossiers sur <br/>
                    Mésures adaptées à vos besoins<br/>
                    et préoccupations</h4>
                </div>
              </div>
           </div>
        </div>
        </div>
            </div>
            </>
    )
  }